module.exports = __webpack_public_path__ + "img/2024_PerformanceWomen.3cc54782.jpg";